const groupLevels = ['level1', 'level2', 'level3']

// Row indexes refer to the existing GROUP_LEVEL renderer's visual rows.
// Reusing header indexes repeats the current category/profile on continuation pages.
export const paginateReportGroups = (item = {}) => {
  const records = Array.isArray(item.value) ? item.value : []
  const capacity = Math.max(parseInt(item.rowPerPage, 10) || 0, 0) || Infinity
  const columns = item.columns || []
  const previous = { level1: null, level2: null, level3: null }
  const activeHeaders = {}
  const pages = []
  let page
  let previousGroup
  let previousParentGroup
  const parentGroupColumn = columns.find((column) =>
    item.fieldVariable?.props?.[column]?.groupDisplay === true &&
    (item.fieldVariable.props[column].groupLevel || 'level1') === 'level1',
  )
  let visualIndex = 0

  const startPage = (groupKey, continued) => {
    const headers = groupLevels.flatMap((level) =>
      activeHeaders[level] === undefined ? [] : [activeHeaders[level]],
    )
    if (headers.length + 1 > capacity) {
      throw new Error('จำนวนแถวต่อหน้าไม่พอสำหรับหัวหมวดและผลตรวจ')
    }
    page = {
      groupKey,
      rowIndexes: [...headers],
      continuedHeaderIndexes: continued ? [...headers] : [],
      recordCount: 0,
    }
    pages.push(page)
  }

  records.forEach((record) => {
    const groupKey = String(record[item.pageBreakGroupBy] ?? '').trim()
    const parentGroup = record[parentGroupColumn]
    const newHeaders = []
    columns.forEach((column) => {
      const props = item.fieldVariable?.props?.[column]
      if (props?.groupDisplay !== true) return
      const level = props.groupLevel || 'level1'
      const value = record[column]
      if (previous[level] === value) return
      const levelIndex = groupLevels.indexOf(level)
      groupLevels.slice(levelIndex + 1).forEach((lower) => {
        previous[lower] = null
        delete activeHeaders[lower]
      })
      previous[level] = value
      activeHeaders[level] = visualIndex
      newHeaders.push(visualIndex++)
    })
    const detailIndex = visualIndex++
    const changedGroup = !page || previousGroup !== groupKey || previousParentGroup !== parentGroup
    if (changedGroup) {
      startPage(groupKey, false)
    } else if (page.rowIndexes.length + newHeaders.length + 1 > capacity) {
      startPage(groupKey, true)
    } else {
      page.rowIndexes.push(...newHeaders)
    }
    page.rowIndexes.push(detailIndex)
    page.recordCount++
    previousGroup = groupKey
    previousParentGroup = parentGroup
  })

  return pages
}
